module.exports = __webpack_public_path__ + "img/Calendar.8b49a17c.svg";